export const EmailConfirmation = () => {
    return <div>EmailConfirmation</div>;
};
